// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e5521a74","455":"7a8473aa","585":"bdb0b7b7","800":"f6f70c7a","977":"e15ff389"}[chunkId] + ".chunk.js";
};